module.exports = __webpack_public_path__ + "static/33-852e99cad69ecb0e00701341911cdb04.mp4";